import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GdprService {
    constructor(private cookieService: CookieService) {}

    setGDPRPreferences(preference: {
        performanceCookies: boolean;
        functionalCookies: boolean;
        targetingCookies: boolean;
    }) {
        this.cookieService.set(
            'cookiesPreferences',
            JSON.stringify(preference),
            365
        );
    }

    shouldShowGDPR() {
        return !this.cookieService.check('cookiesPreferences');
    }
}
